import comJSONData from './comJSONData.vue'

export default comJSONData
